import React from 'react';

import cgLogo from '../../assets/images/cg-logo.svg';
import { getRouteFor, routeNaming } from '../../routes';
import styles from './ErrorHandler.css';

const IPropTypes = {
};

/*
  This component listens for any uncaught error on the whole tree.
  If any error reaches this component, a fallback UI is shown.
*/

// eslint-disable-next-line react/prefer-stateless-function
class ErrorHandler extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <img className={styles.splashLogo} src={cgLogo} alt="" />
        <p>
          Estamos experimentando algunas dificultades en nuestro sitio.
          Por favor intente &nbsp;
          <a className={styles.homeLink} href={getRouteFor(routeNaming.HOME)}>
            volver a la página principal
          </a>
          &nbsp;o contáctenos al 2902 7737
        </p>
      </div>
    );
  }
}

ErrorHandler.propTypes = IPropTypes;

export { ErrorHandler };



// WEBPACK FOOTER //
// ./src/common/error-handler/ErrorHandler.jsx